import React from 'react';
import Marca from 'assets/img/logo/marca.png';
import { Link } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Row, Card, Col, Button, Alert } from 'reactstrap';



export default class Registro extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			nombreUsuario: '',
			email: '',
			password: '',
			rpassword: '',
			conditions: false,
			estadoError: false,
			mensajeError: '',
			visibleError: false
		};
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleRadioButton = () => {
		const currentValue = this.state.conditions;
		this.setState({ conditions: !currentValue });
	};



	// oculta mensaje de error
	onDismiss = () => {
		this.setState({ visibleError: false });
	};

	render() {
		const { loading, nombreUsuario, email, estadoError, mensajeError, visibleError } = this.state;
		
		return (
      <Row style={{ height: '100vh', justifyContent: 'center', alignItems: 'center' }} className="no-mar-h">
				<Col md={6} lg={4}>
					<Card body className="borde-login">
						<Form onSubmit={this.registerUser}>
							<div className="text-center pb-4">
								<img
									src={Marca}
									className="marca-login"
									alt="ETP"
									target='_blank' />
          					</div>
				  			{
								estadoError &&	
									<Alert color="danger" isOpen={visibleError} toggle={this.onDismiss} >
										<h6 className="alert-heading">Error</h6>
										<p>{mensajeError}</p>
									</Alert>
							}

							<FormGroup>
								<Label>Ciclo</Label>
								<select className="select-cuerpo mw100" >
                                    <option>Seleccione</option>
                                    <option>Tercero medio</option>
                                    <option>Cuarto medio</option>
                                </select>
							</FormGroup>
							<FormGroup>
								<Label>RUN</Label>
								<Input onChange={this.handleChange} value={nombreUsuario} placeholder="" type="text"  name="nombreUsuario" />
							</FormGroup>
							<FormGroup>
								<Label>Nombres</Label>
								<Input onChange={this.handleChange} value={nombreUsuario} placeholder="" type="text"  name="nombreUsuario" />
							</FormGroup>
							<FormGroup>
								<Label>Apellidos</Label>
								<Input onChange={this.handleChange} value={nombreUsuario} placeholder="" type="text"  name="nombreUsuario" />
							</FormGroup>

							<FormGroup>
								<Label>Email</Label>
								<Input onChange={this.handleChange} value={email} placeholder="usuario@mail.com" type="email"  name="email" />
							</FormGroup>


							<hr/>
							<Button disabled={loading} size="lg" type="submit" className="bg-gradient-theme-left border-0 btn-block" onClick={this.registerUser}>
								{ loading ? 'Cargando...' : 'Registrar' }
							</Button>
						</Form>

						<div className="text-center pt-1">
							<h6>o</h6>
							<h6> <Link to="/" >Ingresar</Link> </h6>
						</div>

					</Card>
				</Col>
			</Row>
		)
	}
};